import { render, staticRenderFns } from "./ClassRemindersPersonalizations.vue?vue&type=template&id=a49955dc&scoped=true&"
import script from "./ClassRemindersPersonalizations.vue?vue&type=script&lang=js&"
export * from "./ClassRemindersPersonalizations.vue?vue&type=script&lang=js&"
import style0 from "./ClassRemindersPersonalizations.vue?vue&type=style&index=0&id=a49955dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49955dc",
  null
  
)

export default component.exports